//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils/index';
export default {
  components: {
    SearchForm: SearchForm,
    NoData: NoData
  },
  data: function data() {
    return {
      btnType: 'add,search,reset',
      searchFormData: [{
        title: '用户群组名称',
        key: 'userGroupName',
        placeholder: '请输入用户群组名称关键字',
        type: 'input',
        value: null
      }],
      tableData: [],
      filtratedata: {
        pageNum: 1,
        pageSize: 10,
        userGroupName: null
      },
      currentPage: 1,
      loading: false,
      tableheight: 512,
      isIndeterminate: false,
      pageshow: true,
      totalrecord: 0
    };
  },
  created: function created() {
    this.getData();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 345;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 345;
      };
    });
  },
  methods: {
    getData: function getData() {
      var _this = this;
      this.loading = true;
      this.$API.postRequest({
        url: '/platform/userGroup/homePage',
        data: this.filtratedata
      }).then(function (res) {
        _this.loading = false;
        if (res.code === '0000000000') {
          _this.tableData = res.result.records;
          _this.totalrecord = res.result.total;
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      // let checkedCount = val.length;
      // this.delChecked = checkedCount === this.tableData.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
      this.multipleSelection = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.filtratedata.pageNum = val;
      this.getData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.filtratedata.pageSize = val;
      // this.filtratedata.pageNum = 1;
      this.getData();
    },
    searchForm: function searchForm(obj) {
      this.filtratedata.userGroupName = obj[0].value;
      this.filtratedata.pageNum = 1;
      this.getData();
    },
    resetForm: function resetForm() {
      this.searchFormData[0].value = null;
      this.filtratedata.pageNum = 1;
      this.getData();
    },
    delUserGroup: function delUserGroup(item) {
      var _this2 = this;
      this.$API.getRequest({
        url: '/platform/userGroup/deleteUserGroupById',
        data: {
          userGroupId: item.id
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.$message({
            message: '删除成功',
            type: 'success'
          });
          _this2.$refs['power-' + item.id].doClose();
          _this2.getData();
        }
      });
    },
    goToEdit: function goToEdit(item) {
      if (!item) {
        this.$router.push({
          path: '/system/addusergroup'
        });
        return;
      }
      this.$router.push({
        path: '/system/addusergroup',
        query: {
          id: item.id
        }
      });
    },
    goToDetail: function goToDetail(item) {
      this.$router.push({
        path: '/system/viewusergroup',
        query: {
          id: item.id
        }
      });
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};